/* eslint-disable */


/**
 * Create styles for `<Search />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Search />` styles
 */
const SearchStyles = ({ theme }) => ({
  '@keyframes spinnerAnimation': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  heading: {
    padding: `0 ${theme.spacing(1) * 2.3}px 0 ${theme.spacing(1) * 2.3}px`,
  },
  listItemRoot: {
    '&:last-child': {
      marginBottom: theme.spacing(1) * 4.5,
    },
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    padding: 20,
  },
  spinner: {
    animation: `1s spinnerAnimation`,
    color: theme.palette.grey[500],
  },
});

export default SearchStyles;
